import { Injectable } from '@angular/core';
import { Tchek } from '../model/tchek';
import 'parse';
const parse: typeof Parse = require('parse');

interface CachedTchekSoftProps {
  tcheks?: Array<Parse.Object>;
  dateLow?: number;
  dateHigh?: number;
  filters?: Array<string>;
  renewTimestamp?: boolean;
}

interface CachedTchekProps extends CachedTchekSoftProps {
  tcheks: Array<Parse.Object>;
}

@Injectable()
export class CacheService {
  public static Second = 1000;
  public static Minute = 60 * CacheService.Second;
  public static Hour = 60 * CacheService.Minute;
  private positionScrollY: number;
  private tcheks: Array<Parse.Object>;
  private timestamp: Date;
  private filters: Array<string>;
  private lowDateRestriction: number;
  private highDateRestriction: number;

  constructor() {
    this.timestamp = new Date(1);
    this.filters = [];
  }

  setTcheks(props: CachedTchekProps) {
    this.tcheks = props.tcheks;
    this.lowDateRestriction = props.dateLow;
    this.highDateRestriction = props.dateHigh;
    this.timestamp = new Date();
    this.setFilters(props.filters);
  }

  softSetTcheks(props: CachedTchekSoftProps) {
    if (props.tcheks)
      this.tcheks = props.tcheks;
    if (props.dateLow)
      this.lowDateRestriction = props.dateLow;
    if (props.dateHigh)
      this.highDateRestriction = props.dateHigh;
    if (props.filters)
      this.setFilters(props.filters);
    if (props.renewTimestamp)
      this.timestamp = new Date();
  }

  setScrollPosition(y?: number) {
    this.positionScrollY = y;
  }

  getScrollPosition(): number {
    return this.positionScrollY ? this.positionScrollY : 0;
  }

  getTcheks(): Array<Parse.Object> {
    return this.tcheks;
  }

  getTcheksAge(): number {
    return new Date().valueOf() - this.timestamp.valueOf();
  }

  setFilters(filters: Array<string>): Array<string> {
    this.filters = [...filters];
    return this.filters;
  }

  getFilters(): Array<string> {
    return this.filters;
  }

  compareFilters(extFilters: Array<string>): boolean {
    if (extFilters.length !== this.filters.length)
      return false;

    extFilters.forEach(filter => {
      if (!this.filters.includes(filter))
        return false;
    });

    return true;
  }

  compareDateRestrictions(dateLow: number, dateHigh: number) {
    if (dateLow === this.lowDateRestriction && dateHigh === this.highDateRestriction)
      return true;
    else
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/cache.service.ts